<template>
    <v-col cols="12" md="4" ma-1>
        <v-card>
            <v-card-title class="title font-weight-black">
                
            </v-card-title>

            <v-card-text>
                <p><b>Welcome to i-escape</b></p>
                <p>To get started click on the <v-icon>hotel</v-icon> <b>Reservations</b> button to view any upcoming bookings or enquiries from potential customers.</p>
                <p>i-escape supports two types of booking - <b>instant</b> bookings made by i-escape's own booking website on your behalf, and <b>on-request</b> bookings where the customers are free to enquire about custom quotes with you through the i-escape reservation administration system.</p>

                <p>All hotels have the on-request enquiry system enabled, but if you would like i-escape to automatically make bookings for you then please ensure that we always have your availability and rates information.</p>

                <p>You can supply this through iCal feeds, channel manager connections, or through manually managing your availability and rates. Message us on <a href="mailto:channels@i-escape.com?subject=Channel%20Management">channels@i-escape.com</a> for more information</p>

                <!-- <v-checkbox disabled v-model="dontShowAgain"></v-checkbox> <span>Do not show this again</span> -->
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
    /**
     * Display helpful information
     */
    export default {
        props:[],

        data: function() {
            return {
                dontShowAgain: false
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){
        },

        methods: {
            // Dont show again
        }
    }
</script>
